'use strict';

/**
 * Show or hide the add to cart tooltip based on disabeld attribute
 */
function toggleTooltip() {
    var $addToCartButton = $('button.add-to-cart, button.add-to-cart-global, button.update-cart-product-global');
    var action = $addToCartButton.is('[disabled][data-hasoptions="true"]') ? 'show' : 'hide';
    var options = {
        trigger: 'manual',
        container: '.cart-and-ipay'
    };

    if (!$addToCartButton.hasClass('restricted')) {
        $addToCartButton.tooltip(options).tooltip(action);
    }
}

module.exports = {
    init: function () {
        toggleTooltip();

        $(document.body).on('product:updateAddToCart', function () {
            setTimeout(function () {
                toggleTooltip();
            }, 200);
        });
    }
};
